module.exports = {
  "dof-tag-page-container": {
    "flexDirection": "column"
  },
  "slider-margin": {
    "marginTop": "16"
  },
  "dof-tag-page-container-slider": {
    "flex": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-0399fa54!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-tab-page-container/index.vue
// module id = 420
// module chunks = 0 1